import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Typography,
} from '@material-ui/core';
import AddIcon from '@material-ui/icons/Add';
import RemoveIcon from '@material-ui/icons/Remove';
import { useHistory } from 'react-router-dom';
import FormList from '../FormList';
import AlertMessageList from '../AlertMessageList';
import { setAccordeonMotiveOpen } from '../../../../redux/slices/BreadcrumbsSlice';
import { setAuthorized } from '../../../../redux/slices/RoutesAuthSlice';

const MotiveDesktop = ({ ...props }) => {
  const { motives } = props;
  const [expanded, setExpanded] = useState(false);
  const history = useHistory();
  const dispatch = useDispatch();

  const handleGoToUrl = (url) => {
    history.push(url);
  };

  const handleChange = (panel, motive) => (event, isExpanded) => {
    if (isExpanded && motive.authorized)
      dispatch(setAuthorized(motive.authorized));

    if (isExpanded && motive.url) handleGoToUrl(motive.url);
    setExpanded(isExpanded ? panel : false);

    if (isExpanded) dispatch(setAccordeonMotiveOpen(motive.id));
    else dispatch(setAccordeonMotiveOpen(''));
  };

  return (
    <Box width="100%">
      {motives.map((motive, index) => (
        <React.Fragment key={index}>
          <Accordion
            expanded={expanded === index}
            onChange={handleChange(index, motive)}
            elevation={0}
          >
            <AccordionSummary
              expandIcon={expanded === index ? <RemoveIcon /> : <AddIcon />}
            >
              <Typography>{motive.title}</Typography>
            </AccordionSummary>
            <AccordionDetails>
              {motive.alert ? (
                <AlertMessageList mobile={false} motiveId={motive.id} />
              ) : (
                <FormList
                  motiveId={motive.id}
                  issueFormName={motive.issueFormName}
                />
              )}
            </AccordionDetails>
          </Accordion>
        </React.Fragment>
      ))}
    </Box>
  );
};

MotiveDesktop.propTypes = {
  motives: PropTypes.array,
};

export default MotiveDesktop;
